<div class="selected-element" (click)="openDialog()">
  <vdw-ellipsis-label [text]="selectedOption.translationKey | bmsTranslate" matTooltipPosition="above">{{ selectedOption.translationKey | bmsTranslate }}</vdw-ellipsis-label>
  <mat-icon class="icon-24" svgIcon="chevron-down"></mat-icon>
</div>
